export default "__VITE_ASSET__f6a35f42__"